"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAdsExclusionType = void 0;
var GoogleAdsExclusionType;
(function (GoogleAdsExclusionType) {
    GoogleAdsExclusionType["IP_BLOCK"] = "IP_BLOCK";
    GoogleAdsExclusionType["PLACEMENT"] = "PLACEMENT";
    GoogleAdsExclusionType["MOBILE_APPLICATION"] = "MOBILE_APPLICATION";
    /** DEV-2427 — YouTube inventory must be excluded per video/channel, not by placement URL. */
    GoogleAdsExclusionType["YOUTUBE_VIDEO"] = "YOUTUBE_VIDEO";
    GoogleAdsExclusionType["YOUTUBE_CHANNEL"] = "YOUTUBE_CHANNEL";
    GoogleAdsExclusionType["AUDIENCE_EXCLUSIONS"] = "AUDIENCE_EXCLUSIONS";
})(GoogleAdsExclusionType = exports.GoogleAdsExclusionType || (exports.GoogleAdsExclusionType = {}));
